export const nativeShare =
  (window.ccAppJsInterface &&
    window.ccAppJsInterface.share &&
    (data => window.ccAppJsInterface.share(JSON.stringify(data)))) ||
  (window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.share &&
    (data => window.webkit.messageHandlers.share.postMessage(data))) ||
  (navigator.share && (data => navigator.share(data)))

export const isCCApp =
  !!window.ccAppJsInterface || !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share)
